import React from "react";
import LegalPage from "@/pages/legal/LegalPage";

const today = "December 2025";

const Privacy = () => (
  <LegalPage testid="page-privacy" overline="Legal" title="Privacy Policy" lastUpdated={today}>
    <h2>Overview</h2>
    <p>
      The Exit Strategy Society ("ESS," "we," "our," or "us"), a DBA of 4ever Wellness LLC,
      respects your privacy and is committed to protecting the personal information you share
      with us. This Privacy Policy explains what information we collect, how we use it, and
      the choices available to you.
    </p>

    <h2>Information We Collect</h2>
    <p>
      We collect information you voluntarily provide — such as your name, email address,
      phone number, and any messages you submit through our forms. We may also automatically
      collect non-identifying information through cookies and analytics tools to improve our
      website.
    </p>

    <h2>How We Use Your Information</h2>
    <p>
      We use your information to respond to inquiries, deliver requested resources, provide
      services, process purchases, send educational communications, and improve the ESS
      experience. We do not sell your personal information.
    </p>

    <h2>Sharing</h2>
    <p>
      We may share information with trusted service providers (such as payment processors and
      email delivery platforms) who help us operate the website and deliver our services.
      These providers are contractually obligated to protect your information.
    </p>

    <h2>Your Choices</h2>
    <p>
      You may opt out of marketing communications at any time using the unsubscribe link
      provided. You may request access to, correction of, or deletion of your personal
      information by emailing exitstrategysociety@gmail.com.
    </p>

    <h2>Children's Privacy</h2>
    <p>Our services are not directed to individuals under 18.</p>

    <h2>Updates</h2>
    <p>
      We may update this Privacy Policy from time to time. Material changes will be posted on
      this page with an updated effective date.
    </p>
  </LegalPage>
);

export default Privacy;
